if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){
 

    // Remove empty <p> tags created by tinymce
     const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

    const prevArrowHTML =
    `<button aria-label="prev image" class="slick-arrow slick-next prevHiddenClick">
    </button>`;

    const nextArrowtHTML =
    `<button aria-label="next image" class="slick-arrow slick-next">
        <span class="nextArrow"></span>
        <span class="prevArrow"></span>
        <svg width="100" height="100" viewBox="0 0 72 72" preserveAspectRatio="none" fill="none" stroke="currentColor" stroke-width="1">
        <path fill="#231f20" stroke="#fff" stroke-width="0.5px" transform="translate(33 27)"
        d="M.642 17.323a.663.663 0 0 1-.467-1.132l7.424-7.417L.175 1.357A.664.664 0 0 1 .173.42.661.661 0 0 1 1.11.419l7.894 7.886a.664.664 0 0 1 0 .938L1.109 17.13a.659.659 0 0 1-.467.194z"/>
        <circle vector-effect="non-scaling-stroke" cx="36" cy="36" r="35" />
        <circle class="hover" vector-effect="non-scaling-stroke" cx="36" cy="36" r="34" stroke-width="2" />
        </svg>
    </button>`;

    const slickOptions = {
        accessibility: true,
        prevArrow: prevArrowHTML,
        nextArrow: nextArrowtHTML
    };




    $('.js-slick-prev').click(function () {
        const $curSlider = $(this).data('target') ? $($(this).data('target')) : $(this).closest('.sym-slides');
        $curSlider.slick('slickPrev');
     });

    $('.js-slick-next').click(function () {
        const $curSlider = $(this).data('target') ? $($(this).data('target')) : $(this).closest('.sym-slides');
        $curSlider.slick('slickNext');
    });

    $('.sym-slides').slick({
        accessibility: false
    });
    $('.sym-hours').slick({
        accessibility: false,
        arrows:false,
        dots:false,
        fade:true,
        infinite: false,
        autoplay:true,
        autoplaySpeed: 6000,
        nextArrow:slickOptions.nextArrow,
        prevArrow:slickOptions.prevArrow
    });

     //menus
     document.querySelectorAll('.js-menu-tab').forEach((btn) => {
        btn.addEventListener('click', _ => {
            $('.js-menu-tab.active').removeClass('active');
            $(btn).addClass('active');
            $('.quad-menus__menu-content.active').removeClass('active');
            var tabNumber = $(btn).attr('data-menuid');
            var tabToOpen = ".quad-menus__menu-content[data-menuid='" + tabNumber + "']";
            $(tabToOpen).addClass('active');
            $('.quad-menus__tabs-image.active').removeClass('active');
            var imgToOpen = ".quad-menus__tabs-image[data-menuid='" + tabNumber + "']";
            $(imgToOpen).addClass('active');
            $('.name-bg.active').removeClass('active');
            var wordToOpen = ".name-bg[data-menuid='" + tabNumber + "']";
            $(wordToOpen).addClass('active');
        });
    });

})();